import React from "react";

type LiveStatusItem = {
  label: string;
  value: string;
  status: string;
};

const liveStatus: LiveStatusItem[] = [
  {
    label: "Current Point",
    value: "Loading Point",
    status: "on the way",
  },
  {
    label: "Container Status",
    value: "Cargo Loaded",
    status: "30.5 Tons",
  },
  {
    label: "Clearance Status",
    value: "Not yet",
    status: "2 days 12 Hr in CFH",
  },
  {
    label: "Delivery Status",
    value: "In Port",
    status: "2 days 12 Hr in Port",
  },
];

type CustomChipProps = {
  text: string;
  backgroundColor: string;
  textColor: string;
  borderColor: string;
};

const CustomChip: React.FC<CustomChipProps> = ({ text, backgroundColor, textColor, borderColor }) => {
  return (
    <span
      className="px-2 py-1 text-sm font-medium rounded-full border"
      style={{ backgroundColor, color: textColor, borderColor, borderWidth: 1 }}
    >
      {text}
    </span>
  );
};

const LiveStatus: React.FC = () => {
  return (
    <div className="px-3 py-2 border-b border-[#C1C1C1] border-dashed">
      <div className="flex gap-1">
        <p className="text-[16px] leading-[30px] font-[600]">Live Status</p>
        <CustomChip text="Waiting for clearance" backgroundColor="#FFF5EC" textColor="#FFB470" borderColor="#FFB470" />
      </div>
      <div className="flex justify-between gap-1">
        {liveStatus.map((status, index) => (
          <div key={index}>
            <p className="text-[14px] text-[#7E7E7E] font-[400]">{status.label}</p>
            <p className="text-[14px] font-[400]">{status.value}</p>
            <p className="text-[14px] font-[400] text-[#7E7E7E]">{status.status}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LiveStatus;
